/**
 * LE ROUTEUR, EN QUARANTE LIGNES.
 *
 * Une dépendance de routage apporterait des chargeurs de données, des routes imbriquées et un
 * vocabulaire à apprendre ; ce jeu a six écrans et navigue en poussant une URL. La convention du
 * dépôt demande de justifier chaque paquet — celui-là ne se justifie pas.
 *
 * `history.pushState` n'émet pas d'événement : on en émet un nous-mêmes, et tout ce qui affiche un
 * chemin s'y abonne. C'est exactement ce que fait la bibliothèque, en moins de couches.
 */
import { useSyncExternalStore } from "react";

const CHANGEMENT = "destinia:navigation";

function abonne(rappel: () => void): () => void {
  window.addEventListener("popstate", rappel);
  window.addEventListener(CHANGEMENT, rappel);
  return () => {
    window.removeEventListener("popstate", rappel);
    window.removeEventListener(CHANGEMENT, rappel);
  };
}

export function useChemin(): string {
  return useSyncExternalStore(
    abonne,
    () => window.location.pathname,
    () => "/"
  );
}

export function va(chemin: string, options: { remplace?: boolean } = {}): void {
  if (chemin === window.location.pathname) return;
  if (options.remplace) window.history.replaceState(null, "", chemin);
  else window.history.pushState(null, "", chemin);
  window.dispatchEvent(new Event(CHANGEMENT));
  // On remonte en haut : un nœud qui s'ouvre au milieu du texte précédent est un nœud qu'on croit
  // avoir déjà lu.
  window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
}

export function Lien({
  vers,
  children,
  ...reste
}: { vers: string; children: React.ReactNode } & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a
      href={vers}
      {...reste}
      onClick={(evenement) => {
        // Un clic milieu, ou avec une touche de modification, ouvre un onglet : c'est ce que le
        // navigateur fait de mieux, on ne le lui reprend pas.
        if (evenement.defaultPrevented || evenement.metaKey || evenement.ctrlKey || evenement.shiftKey || evenement.button !== 0) return;
        evenement.preventDefault();
        va(vers);
      }}
    >
      {children}
    </a>
  );
}

/** `/partie/abc` contre `/partie/:id` → `{ id: "abc" }`, ou `null` si ça ne correspond pas. */
export function correspond(gabarit: string, chemin: string): Record<string, string> | null {
  const attendus = gabarit.split("/").filter(Boolean);
  const recus = chemin.split("/").filter(Boolean);
  if (attendus.length !== recus.length) return null;
  const parametres: Record<string, string> = {};
  for (let i = 0; i < attendus.length; i += 1) {
    const attendu = attendus[i]!;
    const recu = recus[i]!;
    if (attendu.startsWith(":")) parametres[attendu.slice(1)] = decodeURIComponent(recu);
    else if (attendu !== recu) return null;
  }
  return parametres;
}
